import Todo from '../models/Todo';
import {localAxiosRequest} from "@/utils/axios";
const USERS_BASE_URL = '/users';

/**
 * 获取当前读者购物车数量
 */
const getCartNum = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/carts_num`,
    });
};

/**
 * 获取购物车数据
 */
const getCarts = function (query = null): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/carts?ids=${query}`,
    });
};

/**
 * 获取常用收货地址
 */
const getConsignees = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/consignees`,
    });
};

/**
 * 获取优先收货地址
 */
const getConsignee = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/consignee`,
    });
};

/**
 * 获取待确认订单
 */
const getConfirmCarts = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/confirm_carts`,
    });
};

/**
 * 获取待确认列表数量
 */
const getConfirmQty = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/confirm_qty`,
    });
};

/**
 * 获取全部订单
 */
const getOrderAll = function (page: number, pageSize: number, type: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/allOrders?page=${page}&pageSize=${pageSize}&orderStatusStr=${type}`,
    });
};

/**
 * 获取当前在借
 */
const getLoans = function (page: number, pageSize: number): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/loans?page=${page}&pageSize=${pageSize}`,
    });
};

/**
 * 获取借阅历史
 */
const getLoanHists = function (page: number, pageSize: number): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/loanhists?page=${page}&pageSize=${pageSize}`,
    });
};

/**
 * 获取用户个人信息
 */
const getUsersInfo = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/`,
    });
};

/**
 * 获取用户剩余可借数
 */
const getRemainQty = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/loan_limit`,
    });
};

/**
 * 获取用户已借册数
 */
const getLoanedQty = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/loaned_qty`,
    });
};
/**
 * 获取用户已借册数
 */
const getLoanData = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}//loan_count
`,
    });
};
/**
 * 获取用户信息
 */
const getUserByToken = function (token: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${USERS_BASE_URL}/getUserByToken/${encodeURIComponent(token)}`,
    });
};

export { getCartNum, getCarts, getConsignees, getConsignee, getConfirmCarts, getConfirmQty, getOrderAll, getLoans, getLoanHists, getUsersInfo, getRemainQty, getLoanedQty, getLoanData, getUserByToken };
